import { render } from "./MetaContents.vue?vue&type=template&id=5e33e5de&scoped=true"
import script from "./MetaContents.js?vue&type=script&lang=js"
export * from "./MetaContents.js?vue&type=script&lang=js"

import "./MetaContents.scss?vue&type=style&index=0&id=5e33e5de&lang=scss&scoped=true"

import exportComponent from "C:\\Program Files\\Ampps\\www\\adapter\\metahumen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e33e5de"]])

export default __exports__